import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { jsPDF } from 'jspdf';
import { Canvg } from "canvg";
import html2canvas from "html2canvas";
import { HttpClientModule } from '@angular/common/http';
import { EstimateListService } from './estimate-list-service'; // Adjust path if needed
import { Loading } from '../loading/loading';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule,ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalVariable } from '../globals';
import { EstimateDetailsService } from '../../main/estimate-details/estimate-details-service';
import { GarageDetailsService } from '../garage-details/garage-details-service';

@Component({
  selector: 'estimate-list',
  standalone: true,
  imports: [CommonModule, FormsModule,MatIconModule, Loading,ReactiveFormsModule],
  templateUrl: './estimate-list.html',
  styleUrls: ['./estimate-list.scss']
})
export class EstimateList implements OnInit {
  searchQuery: string = '';
  services: any[] = [];
  isPageLoading = true;
  estimateList: any[] = [];
  selectedCategoryId: number | null = null;
  selectedSubCategoryId: number | null = null;
  categories: any[] = [];
  subCategories: any[] = [];
  noServicesFound: boolean = false;
  vehicleData: any = null;
  loading = false;
  isNavbarWhite = false;
  selectedMake: any;
  selectedModel: any;
  selectedYear: any;
  garageShortName: string = '';
  selectedVariant: any;
  selectedFuelType: any;
   garageKey: string = '';
   callbackForm: FormGroup;
   grandTotal: any;
  showQuickBooking = false;
   showRequestBtn = false;
  labourGstRate: any;
   serviceName: any;
  successMessage: string = '';
  issue: any;
  submitted = false;
  submittedName: string = '';
  submittedMobile: string = '';
  serviceId: any;
  selectedSubCategory: any = null;
  key: any;
  fromPage: string | null = null;
    serviceDetail: any = {
    serviceKitDefinition: {
      image: null,
      notes: null,
      heading: null,
      description: null,
      content: null
    },
    parts: [],
    labours: [],
    whatsIncluded: [],
    faqs: []
  };
   userId = GlobalVariable.userId;
  garageData: any;
  @ViewChild('offcanvasMenu') offcanvasMenu!: ElementRef;
  isModalOpen = false;
  subCategoryId: any;

  constructor(
    private router: Router,
    private garageService: GarageDetailsService,
    private route: ActivatedRoute,
    private estimateService: EstimateListService,
    private fb: FormBuilder,
    private service: EstimateDetailsService
  ) {this.callbackForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
       email: [''],
      issue: [''],
      registrationNumber: ['', [
        Validators.required,
        Validators.pattern('^[A-Z]{2}\\s[0-9]{2}\\s[A-Z]{1,2}\\s[0-9]{4}$')
      ]]
    });}


  ngOnInit(): void {
    this.key = localStorage.getItem('garageKey'); 
     this.route.paramMap.subscribe(params => {
      this.garageKey = params.get('key') || '';
      this.loadServices();
      const nameParam = params.get('name');
      if (nameParam) {
        this.serviceName = nameParam;
      }
    });
    
    this.selectedMake=localStorage.getItem('selectedMake')
    this.selectedModel=localStorage.getItem('selectedModel')
    this.selectedYear=localStorage.getItem('selectedYear')
    this.selectedVariant=localStorage.getItem('variant')
    this.selectedFuelType=localStorage.getItem('fuelType')
    // Initialize services list
    // this.services = [
    //   {
    //     id: 1,
    //     title: "Comprehensive Service",
    //     category: "Brake Pads",
    //     price: "₹1,299",
    //     time: "⏱ 90–120 mins",
    //     tags: ["Genuine Parts", "Autoverse Assured"]
    //   },
    //   {
    //     id: 2,
    //     title: "Engine Oil Change",
    //     category: "Oil Change",
    //     price: "₹1,899",
    //     time: "⏱ 90–120 mins",
    //     tags: ["Warranty", "In-stock"]
    //   },
    //   {
    //     id: 3,
    //     title: "AC Gas Refill",
    //     category: "AC Service",
    //     price: "₹1,899",
    //     time: "⏱ 60–90 mins",
    //     tags: ["Warranty", "In-stock"]
    //   },
    //   {
    //     id: 4,
    //     title: "Rear Brake Pad Replacement",
    //     category: "Rear Brakes",
    //     price: "₹1,199",
    //     time: "⏱ 75–105 mins",
    //     tags: ["Warranty", "In-stock"]
    //   }
    // ];
    this.loadServices();
    this.fetchServices();
    this.loadVehicleData();
    this.loadGarageDetails();
    
  }

  // Filter services based on searchQuery
  get filteredServices() {
    if (!this.searchQuery.trim()) {
      return this.services;
    }
    const q = this.searchQuery.toLowerCase();
    return this.services.filter(s =>
      s.title.toLowerCase().includes(q) || s.category.toLowerCase().includes(q)
    );
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isNavbarWhite = window.scrollY > 50;
  }
clearSearch() {
  this.searchQuery = '';
}

  // Add a service to estimate list
  // addToEstimate(service: any) {
  //   if (this.estimateList.find(item => item.title === service.title)) {
  //     alert(service.title + " is already in estimate.");
  //     return;
  //   }
  //   this.estimateList.push({...service, quantity: 1});
  // }
  addToEstimate(service: any) {
    if (this.estimateList.find(item => item.title === service.title)) {
      alert(service.title + " is already in estimate.");
      return;
    }

    this.estimateList.push({ ...service, quantity: 1 });

    // ✅ STORE selected service details for booking
    this.serviceId = service.id;
    this.issue = service.title;   // 👈 THIS is what we send to API
  }


  // Remove service from estimate list
  removeFromEstimate(service: any) {
    this.estimateList = this.estimateList.filter(item => item.title !== service.title);
  }

  // Clear the entire estimate list
  clearEstimate() {
    this.estimateList = [];
  }
  

  // Increment or decrement quantity
  toggleQuantity(service: any, delta: number) {
    const svc = this.estimateList.find(item => item.title === service.title);
    if (svc) {
      svc.quantity = Math.max(1, svc.quantity + delta);
    }
  }
  // Check if a service is already added
isInEstimate(service: any): boolean {
  return this.estimateList.some(item => item.title === service.title);
}
 goToEstimateDetails(service:any) {
    this.router.navigate(['/estimate-details',service.id,service.title]);
  }
    downloadPDF() {
      // Find the element you want to capture
      const element = document.querySelector('.estimate-main-list-page') as HTMLElement;
      
      // Check if the element exists
      if (!element) {
        console.error('Element not found!');
        return;
      }

      // Capture the element and convert it into a canvas
      html2canvas(element, { scale: 2 }).then(canvas => {
        // Get image data from the canvas
        const imgData = canvas.toDataURL('image/png');

        // Create a new PDF document
        const pdf = new jsPDF('p', 'mm', 'a4'); // 'p' for portrait orientation

        // Get the image properties to maintain aspect ratio
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = 210; // A4 width in millimeters
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        // Add the image to the PDF document
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

        // Save/download the PDF with the given filename
        pdf.save('estimate-details.pdf');
      }).catch(err => {
        console.error('Failed to generate PDF:', err);
      });
    }
    loadServices() {
      this.loading = true;
      this.estimateService.getCategoriesAndSubCategories().subscribe({
        next: (response: any) => {
          if (response.code === 200 && response.data) {
            this.categories = response.data.categories;
            this.subCategories = response.data.subCategories;

            // Calculate count for each category
            this.categories.forEach(cat => {
              const subs = this.subCategories.filter(s => s.categoryId === cat.id);
              cat.subCategoryCount = subs.length;
            });

            // Select first category/subcategory by default
            if (this.categories.length) {
            this.selectedCategoryId = this.categories[0].id;
                      console.log('Selected Category ID:', this.selectedCategoryId);

            const subs = this.subCategories.filter(s => s.categoryId === this.selectedCategoryId);
            if (subs.length) this.selectedSubCategoryId = subs[0].id;
                        console.log('Selected SubCategory ID:', this.selectedSubCategoryId);

          }

            // Assign services directly if present
            this.fetchServices();
          } else {
            console.error('API response invalid', response);
            this.loading = false;
          }
        },
        error: err => console.error('API error', err)
        
      });
    }

    mapCategories(data: any): any[] {
      const services: any[] = [];  // Explicit type annotation added
      if (data.categories) {
        data.categories.forEach((category: any) => {
          if (category.subcategories) {
            category.subcategories.forEach((sub: any) => {
              services.push({
                id: sub.id || sub.name, // fallback if id is missing
                title: sub.name,
                category: category.name,
                price: "₹0", // API may not provide price, adjust as needed
                time: "⏱ N/A", // default value
                tags: ["API Loaded"]
              });
            });
          }
        });
      }
      return services;
    }

    // selectCategory(categoryId: number) {
    //   this.selectedCategoryId = categoryId;

    //   // Use correct property names from API response
    //   const subs = this.subCategories.filter(s => s.categoryId === categoryId);

    //   if (subs.length) {
    //     this.selectedSubCategoryId = subs[0].id; // assuming API returns subcategory id as `id`
    //   } else {
    //     this.selectedSubCategoryId = 0; // fallback if no subcategory
    //   }

    //   this.fetchServices();
    // }
    selectCategory(categoryId: number) {
      this.selectedCategoryId = categoryId;

      const subs = this.subCategories.filter(
        s => s.categoryId === categoryId
      );

      if (subs.length) {
        this.selectedSubCategoryId = subs[0].id;
        this.selectedSubCategory = subs[0];   // ✅ VERY IMPORTANT
      } else {
        this.selectedSubCategoryId = 0;
        this.selectedSubCategory = null;
      }

      this.fetchServices();
    }

    onChildSubCategoryClick(child: any) {
      console.log("Clicked Child:", child);

      // You can now:
      // 1️⃣ Call API with childSubCategoryId
      // 2️⃣ Navigate to details page
      // 3️⃣ Load services based on child id
    }
    // Return only subcategories that have childSubCategory
    get childOnlySubCategories() {
      return this.subCategories.filter(
        s =>
          s.categoryId === this.selectedCategoryId &&
          s.childSubCategory &&
          s.childSubCategory.length > 0
      );
    }

    // Check if current category contains any child structure
    get hasChildSubCategoryInCategory(): boolean {
      return this.childOnlySubCategories.length > 0;
    }
    selectSubCategory(subCategoryId: number) {
      this.selectedSubCategoryId = subCategoryId;
      this.selectedSubCategory = this.subCategories.find(s => s.id === subCategoryId);
      console.log("this.selectedSubCategory =",this.selectedSubCategory);
      this.fetchServices();
    }

    // selectSubCategory(subCategoryId: number) {
    //   this.selectedSubCategoryId = subCategoryId;

    //   this.selectedSubCategory =
    //     this.subCategories.find(s => s.id === subCategoryId);

    //   this.fetchServices();
    // }

    get filteredSubCategories() {
      if (!this.selectedCategoryId) return [];
      return this.subCategories.filter(s => s.categoryId === this.selectedCategoryId);
    }
    fetchServices() {
      let storedVariantKey = localStorage.getItem('variantKey');
      // If not found, try from vehicleData
      if (!storedVariantKey && this.vehicleData?.variantKey) {
        storedVariantKey = this.vehicleData.variantKey;
      }
      const garageKey = localStorage.getItem('garageKey') || '';
      console.log("selectedSubCategory-----",this.selectedSubCategory);
      if(this.selectedSubCategory !=null){
        this.subCategoryId = this.selectedSubCategoryId || 0;
        console.log("hitting if condition")
      }
      console.log("const subCategoryId",this.subCategoryId);
      // const subCategoryId = this.selectedSubCategoryId || 0;
      const payload = {
         garageKey: garageKey,
        // variantKey: storedVariantKey,
        categoryId: this.selectedCategoryId || 0,
        source: "web",
        subCategoryId: this.subCategoryId
      };

      console.log('Calling API with payload:', payload);
      this.loading = true;

      this.estimateService.getServices(payload).subscribe({
        next: (response: any) => {
          this.loading = false;
          console.log("============service-list-api-response", response);

          if (response.code === 200 && response.data && response.data.services) {
            this.services = this.mapServices(response.data.services);
            this.noServicesFound = this.services.length === 0;
          } else if (response.code === 111) {
            this.services = [];
            this.noServicesFound = true;
            this.loading = false;
          } else {
            console.error('Service API response invalid', response);
            this.services = [];
            this.noServicesFound = true;
            this.loading = false;
          }
        },
        error: err => {
          console.error('Service API error', err);
          this.services = [];
          this.noServicesFound = true;
          this.loading = false;
        }
      });
    }


    mapServices(apiServices: any[]): any[] {
      return apiServices.map(service => ({
        id: service.id,
        title: service.name,
        category: "General Service", // or map as needed if you have categories elsewhere
        price: "₹0", // No price provided in API, set default or calculate if possible
        time: "⏱ N/A", // No time provided, set default or calculate
        tags: service.items ? service.items.map((item: { name: any; }) => item.name) : [],
        labourTotal : service.labourTotal
      }));
    }

     goToRegistrationDecode() {
    this.router.navigate(['/registration-decode']);
  }
loadVehicleData() {
  const data = localStorage.getItem('vehicleData');
  if (data) {
    const parsed = JSON.parse(data);

    this.vehicleData = {
      registrationNumber: parsed.registrationNumber,

      // normalize keys for both cases
      make: parsed.make || parsed.selectedMake,
      model: parsed.model || parsed.selectedModel,
      year: parsed.year || parsed.selectedYear,
      fuel: parsed.fuel || parsed.fuelType,

      variant: parsed.variant,
      rowKey: parsed.rowKey,
      variantKey: parsed.variantKey,
    };
  } else {
    this.vehicleData = {
      registrationNumber: '',
      make: '',
      model: '',
      year: '',
      fuel: '',
      variant: '',
      rowKey: '',
      variantKey: ''
    };
  }
}

  goToMake() {
    this.router.navigate(['make']);
  }

    submitForm() {
        this.submitted = true;
    // Mark all fields as touched to trigger validation messages
    this.callbackForm.markAllAsTouched();

    // Stop if form is invalid
    if (this.callbackForm.invalid) {
      return;
    }

    // Check if garage is selected
    const garageKey = localStorage.getItem('garageKey');
    if (!garageKey) {
      alert("Garage not selected!");
      return;
    }

    const { name, mobile, email, issue,registrationNumber } = this.callbackForm.value;
    // this.issue = "Periodic Service";
    // if (this.fromPage === 'periodic') {
    //   this.issue = 'Periodic Service';
    // } else if (this.fromPage === 'denting-painting') {
    //   this.issue = 'Denting & Painting';
    // } else {
    //   this.issue = 'General Service';
    // }
    // If user added from estimate list, use that service name
    this.issue = this.issue || 'Service Request';


    // Prepare payload
    const payload = {
      garageKey: garageKey,
      serviceId: this.serviceId,
      userId: this.userId,
      name,
      phoneNumber: mobile,
      email, // optional
      issue : this.issue,
      registrationNumber: registrationNumber 

    };

    localStorage.setItem("serviceId",this.serviceId);


    this.service.createBooking(payload).subscribe({
      next: (res) => {
        if (res.code === 200) {
          // Set success message
          this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

          // Close request callback modal
          const requestModalEl = document.getElementById('requestCallBackModal');
          const requestModal = (window as any).bootstrap.Modal.getInstance(requestModalEl);
          requestModal?.hide();

          // Show success modal after a short delay
          setTimeout(() => {
            const successModalEl = document.getElementById('successModal');
            if (successModalEl) {
              const successModal = new (window as any).bootstrap.Modal(successModalEl);
              successModal.show();
            }
          }, 200);

          // Store the submitted name and mobile for navigation
          this.submittedName = name;
          this.submittedMobile = mobile;

          // Reset the form
          this.callbackForm.reset();
          this.submitted = false;

        } else {
          alert('Something went wrong. Please try again.');
        }
      },
      error: () => {
        alert('Error creating booking. Please try again.');
      }
    });
  }

  closeSuccessModal() {
    // Close the success modal
    const successModalEl = document.getElementById('successModal');
    const successModal = (window as any).bootstrap.Modal.getInstance(successModalEl);
    successModal?.hide();

    // Navigate to download page
    // this.router.navigate(
    //   ['/estimate-details-download'],
    //   {
    //     state: {
    //       customerName: this.submittedName,
    //       customerPhoneNumber: this.submittedMobile
    //     }
    //   }
    // );
  }
    formatRegistrationNumber() {
  let value = this.callbackForm.get('registrationNumber')?.value || '';

  value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (value.length > 2) value = value.slice(0, 2) + ' ' + value.slice(2);
  if (value.length > 5) value = value.slice(0, 5) + ' ' + value.slice(5);
  if (value.length > 8) value = value.slice(0, 8) + ' ' + value.slice(8, 12);

  this.callbackForm.get('registrationNumber')?.setValue(value, { emitEvent: false });
}
get isCarSelected(): boolean {
  return !!(
    this.vehicleData &&
    (this.vehicleData.registrationNumber ||
     this.vehicleData.make ||
     this.vehicleData.model)
  );
}
openBookingModal(service: any) {
  this.serviceId = service.id;          // store service id
  this.issue = service.title;           // store subcategory name
  console.log("Selected Service:", this.issue);
}
scrollTo(sectionId: string) {
  const el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
goToGarageDetails() {
  this.router.navigate(['/garage-details', this.key]);
}
openRequestModal() {

  // 1️⃣ Close Offcanvas FIRST
  const offcanvasEl = this.offcanvasMenu?.nativeElement;

  if (offcanvasEl) {
    const offcanvasInstance =
      (window as any).bootstrap.Offcanvas.getInstance(offcanvasEl)
      || new (window as any).bootstrap.Offcanvas(offcanvasEl);

    offcanvasInstance.hide();
  }

  // 2️⃣ Open Modal AFTER small delay (important!)
  setTimeout(() => {
    const modalEl = document.getElementById('requestCallBackModal');
    if (modalEl) {
      const modal = new (window as any).bootstrap.Modal(modalEl);
      modal.show();
    }
  }, 300);
}


getServiceMetaInfo(service: any) {
  const name = service?.title?.toLowerCase() || service?.name?.toLowerCase();
  if (!name) return null;

  if (name.includes('oil')) {
    return { time: 'Time Taken: ~4 hours', interval: 'Recommended every: 5,000 km / 3 months' };
  }
  if (name.includes('complete')) {
    return { time: 'Time Taken: ~6 hours', interval: 'Recommended every: 10,000 km / 6 months' };
  }
  if (name.includes('major')) {
    return { time: 'Time Taken: ~8 hours', interval: 'Recommended every: 20,000 km / 12 months' };
  }
  return null;
}
loadGarageDetails() {
  this.isPageLoading = true;

  this.garageService.getGarageDetails(this.key).subscribe({
    next: (res) => {
      if (res.code === 200 && res.data) {
        this.garageData = res.data;

        // ✅ Direct assignment (THIS is what you need)
        this.garageShortName = this.garageData.garageShortName || '';

        // garage logo
        this.garageData.primaryLogo = this.garageData?.garageLogo
          ? this.garageData.garageLogo.split(',')[0].trim()
          : 'assets/img/logos/autoverse-logo-with-text.jpg';

        if (this.garageData.insuranceUrl) {
          this.garageData.insuranceUrls =
            this.garageData.insuranceUrl.split(',').filter((url: any) => url);
        }
      }

      this.isPageLoading = false;
    },
    error: (err) => console.error(err)
  });
}
handleServiceClick(service: any) {

  if (!this.isCarSelected) {
    this.showToast('Please select your car before viewing service details');

    setTimeout(() => {
      const element = document.getElementById('select-car');

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }

    }, 100);
    return;
  }

  this.router.navigate(['/estimate-details', service.id, service.title]);
}
showToast(message: string) {
  const toastEl = document.getElementById('carToast');
  if (toastEl) {
    toastEl.querySelector('.toast-body')!.textContent = message;
    const toast = new (window as any).bootstrap.Toast(toastEl);
    toast.show();
  }
}

}
